export enum EDiseaseEncyclopediaBottomButtonType {
  DiagnosisReservation = 'DIAGNOSIS_RESERVATION',
  None = 'NONE',
  Qna = 'QNA',
}

interface DiseaseEncyclopediaFaqModelVo {
  question: string;
  answer: string;
}

interface DiseaseEncyclopediaBannerModelVo {
  buttonPhrase: string;
  description: string;
  externalUrl: string;
  imageUrl: string;
  title: string;
}

export class DiseaseEncyclopediaBannerModel {
  private buttonPhrase: string;
  private description: string;
  private externalUrl: string;
  private imageUrl: string;
  private title: string;

  constructor(data: DiseaseEncyclopediaBannerModelVo) {
    this.buttonPhrase = data.buttonPhrase;
    this.description = data.description;
    this.externalUrl = data.externalUrl;
    this.imageUrl = data.imageUrl;
    this.title = data.title;
  }

  getButtonPhrase = (): string => {
    return this.buttonPhrase;
  };

  getDescription = (): string => {
    return this.description;
  };

  getExternalUrl = (): string => {
    return this.externalUrl;
  };

  getImageUrl = (): string => {
    return this.imageUrl;
  };

  getTitle = (): string => {
    return this.title;
  };
}

export class DiseaseEncyclopediaFaqModel {
  private question: string;
  private answer: string;

  constructor(data: DiseaseEncyclopediaFaqModelVo) {
    this.question = data.question;
    this.answer = data.answer;
  }

  getQuestion = (): string => {
    return this.question;
  };

  getAnswer = (): string => {
    return this.answer;
  };
}

interface DiseaseEncyclopediaModelVo {
  banner?: DiseaseEncyclopediaBannerModel;
  bottomButtonType?: EDiseaseEncyclopediaBottomButtonType;
  content: string;
  departmentTags?: Array<string>;
  id?: string;
  publicId: string;
  searchTags?: Array<string>;
  title: string;
  titleImageUrl?: string | null;
  symptomTags?: Array<string>;
  faqs?: Array<DiseaseEncyclopediaFaqModel>;
}

class DiseaseEncyclopediaModel {
  private id?: string;
  private publicId: string;
  private bottomButtonType?: EDiseaseEncyclopediaBottomButtonType;
  private content: string;
  private departmentTags?: Array<string>;
  private searchTags?: Array<string>;
  private title: string;
  private titleImageUrl?: string | null;
  private banner?: DiseaseEncyclopediaBannerModel;
  private symptomTags?: Array<string>;
  private faqs?: Array<DiseaseEncyclopediaFaqModel>;

  constructor(data: DiseaseEncyclopediaModelVo) {
    this.id = data.id;
    this.publicId = data.publicId;
    this.bottomButtonType = data.bottomButtonType;
    this.content = data.content;
    this.departmentTags = data.departmentTags;
    this.searchTags = data.searchTags;
    this.title = data.title;
    this.titleImageUrl = data.titleImageUrl;
    this.symptomTags = data.symptomTags;
    this.banner = data.banner;
    this.faqs = data.faqs;
  }

  getDepartmentTags = (): Array<string> => {
    return this.departmentTags ?? [];
  };

  getJoinedDepartmentTags = (): string => {
    return this.departmentTags?.join(', ') ?? '';
  };

  getSearchTags = (): Array<string> => {
    return this.searchTags ?? [];
  };

  getSymptomTags = (): Array<string> => {
    return this.symptomTags ?? [];
  };

  getJoinedSymptomTags = (): string => {
    return this.symptomTags?.join(', ') ?? '';
  };

  getPublicId = (): string => {
    return this.publicId;
  };

  getTitle = (): string => {
    return this.title;
  };

  getTitleImageUrl = (): string | null | undefined => {
    return this.titleImageUrl ?? null;
  };

  getContent = (): string => {
    return this.content;
  };

  getBanner = (): DiseaseEncyclopediaBannerModel | undefined => {
    return this.banner;
  };

  getBottomButtonType = (): EDiseaseEncyclopediaBottomButtonType | undefined => {
    return this.bottomButtonType;
  };

  getFaqs = (): Array<DiseaseEncyclopediaFaqModel> => {
    return this.faqs ?? [];
  };
}

export default DiseaseEncyclopediaModel;
